import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';
import type { Annotation } from '@/_types/documents';

export const getAnnotations = async ({
  companyId,
  extractedDocumentId,
  token,
}: APIRequest<{
  companyId: number;
  extractedDocumentId: number;
}>): APIResponsePromise<Array<Annotation>> =>
  await _callBackend(
    `/extracted_documents/${extractedDocumentId}/get_annotations`,
    'POST',
    { company_id: companyId },
    token,
  );

export const saveAnnotations = async ({
  companyId,
  extractedDocumentId,
  annotations,
  token,
}: APIRequest<{
  companyId: number;
  extractedDocumentId: number;
  annotations: any;
}>): APIResponsePromise<Array<Annotation>> =>
  await _callBackend(
    `/extracted_documents/${extractedDocumentId}/save_annotations`,
    'POST',
    { company_id: companyId, annotations },
    token,
  );
